import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { faqs } from "../data/site";
import { Seo, breadcrumbLd } from "../components/Seo";
import { PageHero, CTABand } from "../components/ui-blocks";
import { IMG } from "../data/site";

const FAQ_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

const FAQ_JSONLD = [FAQ_LD, breadcrumbLd([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }])];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <div>
      <Seo
        title="Frequently Asked Questions"
        description="Answers to common questions about estimates, service areas, materials, residential and commercial projects, and stone surface care."
        path="/faq"
        jsonLd={FAQ_JSONLD}
      />
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        subtitle="Everything you need to know before starting your stone project."
        image={IMG.graniteTexture}
        testid="faq-hero"
      />

      <section className="section bg-white">
        <div className="container-custom max-w-3xl">
          <div className="divide-y divide-neutral-200 border-y border-neutral-200">
            {faqs.map((f, i) => (
              <div key={f.question} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left"
                  aria-expanded={open === i}
                >
                  <span className="text-lg font-medium text-neutral-900 font-display">{f.question}</span>
                  <ChevronDown size={20} className={`text-[#CD1422] shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
                </button>
                {open === i && <p className="text-neutral-600 leading-relaxed pb-6 -mt-1">{f.answer}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default FAQ;
